<template>
  <div id="changeEmail" class="changeEmail">
    <DialogEidt :value="isShow" @close="closeDialog">
      <template v-slot:title>
        <div>修改邮箱</div>
      </template>
      <template v-slot:body>
        <div class="main-info p24 check-price-form">
          <el-form
            ref="formData"
            :model="formData"
            :rules="allRules"
            label-position="top"
            size="medium"
            class="item-Surcharge"
            @submit.native.prevent
          >
            <el-form-item class="flex-width_1" prop="email" label="新邮箱">
              <el-input v-model="formData.email" />
            </el-form-item>
            <el-form-item class="flex-width_1" prop="password" label="登录密码">
              <el-input v-model="formData.password" type="password" />
            </el-form-item>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <div class="foot-class">
          <button class="cancel" @click="closeDialog">取消</button>
          <button class="save by-button--primary" @click="clickSave">保存</button>
        </div>
      </template>
    </DialogEidt>
  </div>
</template>

<script>
import DialogEidt from '../../../components/Dialog/Dialog.vue'
import request from '@/utils/request'
import { getCookie } from '@/utils/cookiejs'
export default {
  name: 'ChangeEmail',
  components: {
    // 组件的引用
    DialogEidt
  },
  props: {
    // 父辈向子辈传参
    isShow: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    return {
      formData: {
        email: '',
        password: ''
      },
      token: '',
      btnLoading: false,
      allRules: {
        email: [
          { required: true, trigger: 'blur', message: 'Please enter email address.' },
          {
			    pattern: /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/,
			    message: 'The email you entered is incorrect. Please try again.',
            trigger: 'blur'
			  }
        ],
        password: [
          { required: true, trigger: 'blur', message: 'Please enter password.' }
        ]
      }
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    this.token = getCookie('token')
    if (this.token) {
      this.getCustomerInfo()
    }
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    closeDialog() {
      this.$emit('close', false)
    },
    clickSave() {
      // 表单校验
      this.$refs['formData'].validate((val) => {
        // console.log("====校验", val);
        if (val) {
          request({
            url: '/Config/Actions/CheckMail',
            method: 'POST',
            data: this.formData,
            headers: {
              Authorization: this.token
            }
          }).then((res) => {
            this.$message({
              message: res.msg,
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.btnLoading = false
                this.closeDialog()
                this.$emit('refresh', true)
              }
            })
          }).finally(() => {
            this.btnLoading = false
          })
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
::v-deep .dialog__header{
    text-align: left ;
}
::v-deep .dialog__body{
    padding:0;
    .el-form-item{
        margin-bottom: 0;
        .el-form-item__label{
            float: left;
        }
    }
}
::v-deep .el-form-item__error {
	display: block !important;
}
.foot-class{
    margin: 24px 0;
    padding-bottom: 24px;
    text-align: right;
    .cancel{
       width: 72px;
       height: 32px;
       background: #FFFFFF;
       border-radius: 4px;
       border: 1px solid #DDDDDD;
       font-size: 14px;
       font-family: PingFangSC, PingFang SC;
       font-weight: 500;
       color: #333333;
       margin-right: 16px;
       cursor: pointer;
    }
    .save{
        width: 72px;
        height: 32px;
        border-radius: 4px;
        cursor: pointer;
    }
}
</style>
